import { Campaign } from 'src/app/models/campaign';
import { Content } from 'src/app/models/content';
import { Insight } from 'src/app/models/insight';
import { ENVIRONMENTS, PAYLOAD_TYPES } from 'src/app/shared/constants/general-constants';
import { ENVIRONMENT } from 'src/environments/environment';

export const buildPayloadRecord = (type: string) => {
  const record: any = {
    action_display: '',
    payload_record_type: '',
    content_html_id: null,
    content_html_display_order: null,
    content_text_id: null,
    context_text_display_order: null,
    image_id: null,
    image_display_order: null
  };
  if (type === 'so') {
    record.action_display = PAYLOAD_TYPES.PERSONALIZED_TEMPLATE;
    record.payload_record_type = PAYLOAD_TYPES.PERSONALIZED_OFFER;
  } else if (type === 'ct') {
    record.action_display = PAYLOAD_TYPES.FULL_MODAL;
    record.payload_record_type = PAYLOAD_TYPES.CONTEXTUAL_MSG;
  } else if (type === 'mc') {
    record.action_display = PAYLOAD_TYPES.TEMPLATE;
    record.payload_record_type = PAYLOAD_TYPES.MSG_CENTER;
  }

  return record;
};

export const prepareContentPayload = (contentForm, campaignForm, username, type): any => {
  const contentPayload = new Content();
  contentPayload.action_button = contentForm.value.action_button
    ? [
        {
          text_id: contentForm.value.text_id,
          text: contentForm.value.text,
          destination_uri_id: contentForm.value.destination_uri_id,
          destination_uri: contentForm.value.destination_uri,
          destination_type: contentForm.value.destination_type
        }
      ]
    : [];
  contentPayload.action_type = 'content';
  contentPayload.category_icon_id = contentForm.value.category_icon_id;
  contentPayload.category_title_id = contentForm.value.category_title_id;
  contentPayload.category_title_text = contentForm.value.category_title_text;
  contentPayload.created_by = username;
  contentPayload.deleted = false;
  contentPayload.display_type = 'separate_view';
  contentPayload.headline_text_id = contentForm.value.headline_text_id;
  contentPayload.headline_text = contentForm.value.headline_text;
  contentPayload.language = 'en';
  contentPayload.last_updated_by = username;
  contentPayload.locale = 'en-US';
  contentPayload.min_app_version = campaignForm.value.prime ? '0.0.0' : '4.3.0';
  if (type === 'ct') {
    contentPayload.active_parent_uri_id = contentForm.value.active_parent_uri_id;
  }

  const record = buildPayloadRecord(type);

  if (!campaignForm.value.non_localization_campaign) {
    contentForm.get('payload').controls.forEach((ctrl, idx) => {
      const key = (ctrl.get('key')?.value || '').toLowerCase();
      const rawId = ctrl.get('id')?.value;
      const id = rawId ? rawId : null;

      if (key.includes('html')) {
        record.content_html_id = id;
        record.content_html_display_order = id !== null ? idx : null;
      } else if (key.includes('text')) {
        record.content_text_id = id;
        record.context_text_display_order = id !== null ? idx : null;
      } else if (key.includes('image')) {
        record.image_id = id;
        record.image_display_order = id !== null ? idx : null;
      }
    });
  } else {
    contentForm.get('payload').controls.forEach((ctrl, idx) => {
      const key = (ctrl.get('key')?.value || '').toLowerCase();
      const rawId = ctrl.get('id')?.value;
      const id = rawId ? rawId : null;

      if (key.includes('html')) {
        record.content_html = id;
        record.content_html_display_order = id !== null ? idx : null;
      } else if (key.includes('text')) {
        record.content_text = id;
        record.context_text_display_order = id !== null ? idx : null;
      } else if (key.includes('image')) {
        record.image_url = id;
        record.image_display_order = id !== null ? idx : null;
      }
    });
  }

  contentPayload.payload_records = [record];

  return contentPayload;
};

export const prepareTriggerPayload = (campaignForm, triggerForm, username, dateService): any => {
  const trigger = new Insight();
  const randomId = Math.random().toString(36).substring(2, 8);
  trigger.created_by = username;
  trigger.last_updated_by = username;
  trigger.enabled = false;
  if (ENVIRONMENT.name !== ENVIRONMENTS.STAGE) {
    trigger.end_date = campaignForm.value.endDate.getTime() / 1000;
    trigger.start_date = dateService.addHours(campaignForm.value.startDate, -2).getTime() / 1000; // Insight will start 2h earlier than campaign
  }
  trigger.name = 'insight-' + randomId + '-' + campaignForm.value.campaignName;
  trigger.description = campaignForm.value.description;
  trigger.query = triggerForm.value.query;
  trigger.schedule_seconds = 86400;
  trigger.category = 'ecommerce';

  return trigger;
};

export const prepareCampaignPayload = (contentId: number, triggerId: string, campaignForm, type, username): any => {
  const campaign = new Campaign();
  if (type === 'so') {
    campaign.campaign_type = 'eCommerce';
  } else if (type === 'ct') {
    campaign.campaign_type = 'ContextualMessage';
  } else if (type === 'mc') {
    campaign.campaign_type = 'Notification2';
  }
  campaign.content_id = contentId;
  campaign.created_by = username;
  campaign.description = campaignForm.value.description;
  campaign.frequency_days = 365;
  campaign.is_real_time = false;
  campaign.last_updated_by = username;
  campaign.name = campaignForm.value.campaignName;
  campaign.trigger_id = triggerId;
  campaign.enabled = false;
  campaign.responses = [];
  if (ENVIRONMENT.name !== ENVIRONMENTS.STAGE) {
    campaign.start_date = campaignForm.value.startDate.getTime() / 1000;
    campaign.end_date = campaignForm.value.endDate.getTime() / 1000;
  }

  return campaign;
};
